import { axios } from '../lib/axios';

export async function postNewImages(files) {
  await axios.post(`${API_URL}/images`, files);
}
